<template>
  <div class="main-login"  v-if="!usuarioLogado">
     <div class="wrapper">
        <figure class="logo">
            <img src="./assets/logo.png">
            <figcaption>
                <h1>Ponto de Equilibrio v0.1</h1>
                <h2>Entre a Cruz e a Espada</h2>
                
            </figcaption>
        </figure>  
            <div class="quadro-login">
                <div class="form-novo">
                    <div class="card">

                        <div class="input-group">
                            <label>Login</label>  
                            <select v-model="usuario.login">
                                <option  v-for="usuarios in listaUsuarios" :key="Cod_usuario">
                                    {{usuarios.Cod_usuario}}-{{usuarios.Nome_usuario}}
                                </option>
                            </select>                                
                        </div>     
                        <div class="input-group">
                            <label>Password</label>  
                            <input type="password" v-model="usuario.senha">  
                        </div>       
                        <div class="button-group">
                            <button @click="efetuarLogin">Acessar</button>
                        </div>                                                   
            
                    </div>
                </div>  
          </div>
     </div>
  </div>

  <div class="body" v-if="usuarioLogado">
    <nav class="main-menu">
          <div class="wrapper">
              <figure class="logo">
                  <img src="./assets/logo.png">
                  <figcaption>
                      <h1>Ponto de Equilibrio</h1>
                      <h2>Entre a Cruz e a Espada</h2>
                     
                  </figcaption>

              </figure>
              <ul class="botoes">
                  <li><router-link to="/receitas/cadastro" class="botao">Receitas</router-link></li>
                  <li><router-link to="/gastos" class="botao">Gastos</router-link></li>
                  <li><router-link to="/" class="botao">Poupar</router-link></li>
                  <li><router-link to="/caixa/cadastro" class="botao">Extrato</router-link></li>
                  <li><router-link to="/mais" class="botao">Mais +</router-link></li>
              </ul>
          </div>
      </nav>

    <router-view/>
 </div>
</template>

<script>
import api from './services/api.js';
export default {
  data: () => ({

      usuario: {
          login:'',
          senha:''
      },
      listaUsuarios:[],
      usuarioLogado: false
  }),
  methods: {
        efetuarLogin () {
            console.log('login');  
            console.log(this.usuario);  

            api.post('usuario',this.usuario)        
            .then(response => {  
                console.log('login '+response.data.retorno);
                console.log(response.data);

                if (response.data.retorno=="OK"){
                    this.usuarioLogado = true;
                    localStorage.setItem('usuarioLogado', 'true'); 
                    localStorage.setItem('nomeUsuarioLogado', this.usuario.login); 
                    this.$router.push('/');  
                }
                else    
                    alert('Senha incorreta');                        


            }).catch( error => {
                console.log(error);  
                alert('Error - Login \n'+'-'+error.response.data);
            });


              

        },
        async listarUsuario(){
            try {
                let url = `/usuario/lista`;
                const response = await api.get(url); // Aguarda a resposta da API


                this.listaUsuarios = response.data.qry;


            } catch (error) {
                console.log(error);
                alert('Error - lista usuario \n' + '-' + error.response?.data || error.message);
            }
        }        

  },  
  computed:{  
    usuarioestaLogado(){
      alert('usuarioestaLogado');
      this.usuarioLogado =  localStorage.getItem('usuarioLogado');
    }    
  },
  mounted() {
      

    
  },
  async created(){
    await this.listarUsuario();

  }

}
</script>


<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');
  @import './css/reset.css';
  @import './css/index.css';

  @import './css/components/main-menu.css';
  @import './css/components/main-body.css';
  @import './css/components/main-destaque.css';
  @import './css/components/main-grafico.css';
@import './css/components/main-login.css';
</style>
